import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import numberFormat from "ati-utils/numberFormat";

import { sendNavigationMetric } from "../../utils/sendMetric";

import strings from "../../locales/strings";

import styles from "./OnlineLoansButton.scss";

const cx = classnames.bind(styles);

const roles = {
  0: "carrier",
  1: "dispatcher",
  2: "top-dispatcher",
  3: "fuel",
};

const OnlineLoansButton = React.forwardRef(
  ({ baseUrl, loanLimit, className, role, locale }, ref) => {
    if (!loanLimit || locale !== "ru") {
      return null;
    }

    const formattedNum = numberFormat(loanLimit);

    return (
      <a
        ref={ref}
        className={cx("online-loans-button", className)}
        href={`https://${baseUrl}/bridge-capital/?utm_source=header&utm_campaign=new_header`}
        target="_blank"
        onClick={() => sendNavigationMetric("ONLINE_LOANS")}
      >
        {roles[role] === "fuel"
          ? `${formattedNum} ₽ ${strings.loan_forFuel}`
          : `${strings.loanAvailable} ${formattedNum} ₽`}
      </a>
    );
  }
);

OnlineLoansButton.defaultProps = {
  baseUrl: "ati.su",
  locale: "ru",
};

OnlineLoansButton.propTypes = {
  baseUrl: PropTypes.string,
  loanLimit: PropTypes.number,
  className: PropTypes.string,
  locale: PropTypes.string,
  role: PropTypes.number,
};

export default OnlineLoansButton;
